export enum WorkOrderListViewMode {
    InvoicingCustomers = 'Customer Billing',
    InvoicingContractors = 'Subcontractor (RCTI)',
    OperationsJobs = 'OperationsJobs',
    OperationsWorkorders = 'OperationsWorkorders',
    OperationsWorkordersByJob = 'OperationsWorkordersByJob',
    PurchaseOrders = 'PurchaseOrders'
}